import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "e7192kvKrRMs6E3pRrfM37K", "FitBg", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, view, size, UITransform } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
/**将此组件添加在 背景节点上 */

var FitBg = (_dec = menu("fit/fitBg"), ccclass(_class = _dec(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FitBg, _Component);

  function FitBg() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FitBg.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {
    /**showAll 适配时 的缩放 */
    var canvasSize = view.getCanvasSize();
    var designSize = size(1280, 720);
    var scaleForShowAll = Math.min(canvasSize.width / designSize.width, canvasSize.height / designSize.height);
    /**showAll 模式下 的实际展示宽高 */

    var realSize = size(designSize.width * scaleForShowAll, designSize.height * scaleForShowAll);
    /**showAll模式下， 短边拉伸至屏幕尺寸 */

    var scaleForFit = Math.max(canvasSize.width / realSize.width, canvasSize.height / realSize.height);
    /**重置宽高 */

    var uiTF = this.node.getComponent(UITransform);
    uiTF.setContentSize(size(uiTF.width *= scaleForFit, uiTF.height * scaleForFit));
  };

  _proto.start = function start() {} // update (dt) {}
  ;

  return FitBg;
}(Component)) || _class) || _class);
export { FitBg as default };

_cclegacy._RF.pop();